<template>
  <div>
    <div class="top-icon-wrapper text-center pb-4">
      <img
        :src="require('@/assets/mail.svg')"
        width="49"
        height="44"
        alt="send airplane icon"
      />
    </div>

    <div class="text-center">
      <div class="text-sf-pro text-20">Sent another confirmation email to</div>
      <div class="text-sf-pro email">{{ userEmail }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      userEmail: state => state.app.onboarding.email,
    }),
  },
};
</script>

<style lang="scss" scoped>
.text-sf-pro {
  color: #000;
  font-family: DM Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.text-20 {
  font-size: 20px !important;
}

.email {
  color: #4f56ff !important;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// confirmEmail.vue?9202d0a6